// Global Context for notistack package
import React from "react";
import { SnackbarProvider } from 'notistack';

export const AppAlert: React.FC<{ children: JSX.Element }> = ({ children }) => {
    return <SnackbarProvider maxSnack={3} preventDuplicate>
        {children}
    </SnackbarProvider>
}